export default __webpack_public_path__ + "static/media/Dr._Erika_Michalski_AHV_In_Moms_We_Trust.5fbdab1c.jpg";